import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=7566db2e&scoped=true"
import script from "./commission.vue?vue&type=script&lang=js"
export * from "./commission.vue?vue&type=script&lang=js"
import style0 from "./commission.vue?vue&type=style&index=0&id=7566db2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7566db2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7566db2e')) {
      api.createRecord('7566db2e', component.options)
    } else {
      api.reload('7566db2e', component.options)
    }
    module.hot.accept("./commission.vue?vue&type=template&id=7566db2e&scoped=true", function () {
      api.rerender('7566db2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/commission.vue"
export default component.exports